import { showToast } from './toast.js';

export function initPolish() {
  installErrorToasts();
}

function installErrorToasts() {
  window.addEventListener('error', (event) => {
    showToast(`Runtime error: ${event.message || 'unknown'}`, 3000);
  });
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason?.message || String(event.reason || 'unknown');
    showToast(`Async error: ${reason}`, 3000);
  });
}
